import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  
  // Check both isAuthenticated flag and user object for better reliability
  return (isAuthenticated && user) ? <Outlet /> : <Navigate to="user/login" />;
};

export default PrivateRoute;